import { makeStyles } from '@material-ui/core'

export default makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
  },
}))
